module.exports = __webpack_public_path__ + "img/landing-craft-transport-icon.deeb4b50.svg";